module.exports = __webpack_public_path__ + "static/media/second-publish-explain-en.3698f8aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/second-publish-explain-en.png
// module id = 1163
// module chunks = 110